import { render, staticRenderFns } from "./IntegrationsWizard.vue?vue&type=template&id=13a97975&scoped=true&"
import script from "./IntegrationsWizard.vue?vue&type=script&lang=js&"
export * from "./IntegrationsWizard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsWizard.vue?vue&type=style&index=0&id=13a97975&lang=scss&scoped=true&"
import style1 from "./IntegrationsWizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a97975",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsWizard.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VOverlay,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
